import { TreatmentMessageTemplateEditModel } from '../../../core/model';
import { TreatmentMessageTemplate } from '../bulk-delivery-dialog/default-messages';

export interface EditTreatmentMessageTemplateDialogConfig {
    instruction: TreatmentMessageTemplateEditModel;
    models: TreatmentMessageTemplate[];
}
